import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SUPERIORCLASIFICATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SuperiorClasification.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SuperiorClasification.Code')
    .required()
    .maxLength(10)
    .build(),
];

export const SUPERIORCLASIFICATION_CONFIG = {
  entityName: 'SuperiorClasification',
  localizationKey: 'Planning::Entity.SuperiorClasification',
  fields: SUPERIORCLASIFICATION_FIELDS,
  permission: 'PlanningEnvironment.SuperiorClasifications',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
